module.exports = __webpack_public_path__ + "img/11.53de33dd.jpg";